import React from "react";
import styles from "../utils/gridStyles.js";
import dateFormat from 'dateformat';
import setHeaderRender from "../../components/app/setHeaderRender.js";

const setColumnsSub = ({ modalDetail, allowWrite, changeDelay}) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
        },
        {
            id: "code",
            field: "code",
            label: "Code",
            width: '100px',
            sortable: false,
            resizable: true

        },
        {
            id: "2",
            field: "clienteEmail",
            label: "ClienteEmail",
            width: '210px',
            sortable: false,
            resizable: true,
        },
        {
            id: "3",
            field: "planIdExterno",
            label: "PlanIdExterno",
            width: '210px',
            sortable: false,
            resizable: true,
        },
        {
            id: "typeEvent",
            field: "typeEvent",
            label: "Tipo Evento",
            width: '230px',
            sortable: false
        },
        {
            id: "4",
            field: "endpoint",
            label: "Endpoint",
            width: '310px',
            sortable: false
        },
        {
            id: "5",
            field: "method",
            label: "Method",
            width: '110px',
            sortable: false,
        },
        {
            id: "6",
            field: "ip",
            label: "Ip",
            sortable: false,
        },
        {
            id: "8",
            field: "createdAt",
            label: "CreatedAt",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.createdAt, "dd/mm/yyyy HH:mm:ss ", true)),
            sort: ({ a, b, isAscending }) => {
                let aa = a.split("/").reverse().join(),
                    bb = b.split("/").reverse().join();
                return aa < bb
                    ? isAscending
                        ? -1
                        : 1
                    : aa > bb
                        ? isAscending
                            ? 1
                            : -1
                        : 0;
            }
        },
        {
            id: "buttons",
            label: "Action",
            width: '120px',
            pinned: true,
            sortable: false,
            resizable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (
                <div style={styles.styleButton.buttonsCellContainer}>
                    <button
                        title="View"
                        style={styles.styleButton.viewButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            modalDetail(data.code, "View");
                        }}
                    >
                        {styles.VIEW_SVG}
                    </button>
                </div>
            )
        }
    ];
};

export default setColumnsSub;
